export default {"src":"/_next/static/media/jacuzzi.d1687436.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};